module.exports = __webpack_public_path__ + "static/media/20_blanco.4e1e7a48.svg";